import { BaSeBreakpointContext } from '@base/react';
import * as React from 'react';

export function useBreakpoint() {
  const {
    onMobileSmall,
    onMobile,
    onMobileLarge,
    onTablet,
    onDesktop,
    onDesktopLarge,
  } = React.useContext(BaSeBreakpointContext);
  const isDesktop = React.useCallback(
    () => onDesktop || onDesktopLarge,
    [onDesktop, onDesktopLarge],
  );

  const isMobile = React.useCallback(
    () => onMobileSmall || onMobile || onMobileLarge,
    [onMobile, onMobileLarge, onMobileSmall],
  );

  const isAllMobile = React.useCallback(
    () => onTablet || onMobileSmall || onMobile || onMobileLarge,
    [onMobile, onMobileLarge, onMobileSmall, onTablet],
  );
  return { isDesktop, isMobile, isAllMobile };
}
